import './auth-ui.module.scss';
import Login from './login';
import './auth-ui.scss';
import { AuthUIScaffold } from './components/AuthUIScaffold';
import { Route, Routes, useLocation } from 'react-router-dom';
import SignupContainer from './components/SignupContainer';
import ResetPassword from './components/ResetPassword';
import { RecaptchaAuthComponent } from './components/RecaptchaAuthComponent';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface AuthUiProps {}

export function AuthUi(props: AuthUiProps) {
  const [submitDisable, setSubmitDisable] = useState<boolean>(false);
  const location = useLocation();

  return (
    <AuthUIScaffold>
      <Routes>
        <Route path="/" element={<Login submitDisable={submitDisable} />} />
        {location?.pathname}
        <Route path="/signup" element={<SignupContainer submitDisable={submitDisable} />} />
        <Route path="/reset-password" element={<ResetPassword submitDisable={submitDisable} />} />
        <Route path="*" element={<Login submitDisable={submitDisable} />} />
      </Routes>
      <RecaptchaAuthComponent
        onResolved={(isResolved) => {
          setSubmitDisable(!isResolved);
        }}
      />
    </AuthUIScaffold>
  );
}

export default AuthUi;
